<template>
  <div>
    <rj-tabs v-model="tabsActive">
      <rj-tab-pane name="1">
        <span slot="label">待审批提前开票</span>
        <make-approval ref="makeApprovalRef" />
      </rj-tab-pane>
      <rj-tab-pane name="2">
        <span slot="label">已审批提前开票</span>
        <approval ref="approvalRef" />
      </rj-tab-pane>
    </rj-tabs>
  </div>
</template>
<script>
import tabs from '@/components/Tabs/tabs';
import tabPane from '@/components/Tabs/tabPane';
import makeApproval from './components/makeApproval.vue';
import approval from './components/approval.vue';
export default {
  name: 'OpenTicketManagmentOfcontractAsWhole',
  components: {
    'rj-tab-pane': tabPane,
    'rj-tabs': tabs,
    makeApproval,
    approval
  },
  computed: {
    tabsActive: {
      get () {
        return this.$store.state.pagesTemporary.openTicketManagmentOfOrder;
      },
      set (val) {
        if (val === '1') {
          this.$refs.makeApprovalRef && this.$refs.makeApprovalRef.initData();
          this.$refs.approvalRef.resetFormValue();
        } else if (val === '2') {
          this.$refs.approvalRef && this.$refs.approvalRef.initData();
          this.$refs.makeApprovalRef.resetFormValue();
        }
        this.$store.commit('pagesTemporary/SETOpenTicketManagmentOfOrder', val);
      }
    } }
};
</script>
